"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Filter = _interopRequireDefault(require("./Filter"));

var _default = function _default(response) {
  var errMsg = response.errMsg,
      config = response.config;

  if (errMsg !== '') {
    return response;
  }

  return _Filter["default"].filterIterator(config.filter, function (filter) {
    return filter.response({
      data: response.data,
      config: config
    }).then(function (_ref) {
      var data = _ref.data;
      return Object.assign(response, {
        data: data
      });
    });
  }, true).then(function () {
    return response;
  });
};

exports["default"] = _default;